import { useState, useMemo, useEffect } from "react";

import {
  CircularProgress,
  Typography,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Modal,
  Button,
  Tooltip,
  InputAdornment,
  IconButton,
  Grid,
  FormControlLabel,
  Switch
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import Logocolor from "../../../Image/Logo.png";
import { CalendarToday } from "@mui/icons-material";
import { FaTrashCan } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { DataGrid } from "@mui/x-data-grid";
import { DiseñoDataGrid } from "../../FuncionesGenerales/DataGrid";
import { formatCLP } from "../../FuncionesGenerales/FormatoCLP";
import {  buttonGuardar, InputDescripcion, Input, inputFechaGrande, modalStyle, InputBuscador, buttonCancelar, Titulo, SubTitulodos } from "../../../Layouts/CustomStyles";
import { useGetEgresosRME, useEgresoRME, useGetCategoriasRME, useEgresoProveedoresRME } from "../../../Services/EgresosRME";
import { useGetSucursal } from "../../../Services/Sucursales";
import { BsPersonVcard } from "react-icons/bs";
import { FormatRut } from "../../../Components/FuncionesGenerales/Rut";

export const PaginaEgreso = ({ actualizarTabla }) => {
  const { editarEgresoRME, eliminarEgresoRME, descargarPdfEgreso, editarCuota } = useEgresoRME();
  const { egresosrme, loadingEgresos, refetch } = useGetEgresosRME();
  const { proveedores,  refetchProveedores } = useEgresoProveedoresRME();
  const { categorias } = useGetCategoriasRME();
  const { sucursales } = useGetSucursal();
  const [openEliminar, setOpenEliminar] = useState(false);
  const [egresoSeleccionado, setEgresoSeleccionado] = useState(null);
  const [successAlertOpen, setSuccessAlertOpen] = useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = useState(false);
  const [enviandoAlert, setEnviandoAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [openEditar, setOpenEditar] = useState(false);
  const [openDetalle, setOpenDetalle] = useState(false);
  const [filtroFecha, setFiltroFecha] = useState("");
  const [aplicarRetencion, setAplicarRetencion] = useState(false);
  const [filtroMes, setFiltroMes] = useState("");
  const [filtroAno, setFiltroAno] = useState("");
  const [filtroCategoria, setFiltroCategoria] = useState("");
  const pdfUrl = egresoSeleccionado?.documento_adjunto
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [distributions, setDistributions] = useState([]);
  const [cuotas, setCuotas] = useState([]);
  const [tipoFecha, setTipoFecha] = useState("date");

  useEffect(() => {

    refetch(
        filtroMes,
        filtroAno,
        tipoFecha,
        filtroCategoria
    );

}, [
    filtroMes,
    filtroAno,
    tipoFecha,
    filtroCategoria
]);

  const handleOpenEdit = (row) => {
    

  setEgresoSeleccionado({
    ...row,
    documento_adjunto: null,
    proveedor_id: row.proveedor_id ?? "",
    proveedor: row.proveedor ?? {
      razon_social: "",
      rut_proveedor: "",
      email: "",
    },
    detalle_pago: row.detalle_pago ?? {
      medio_pago: "",
      cuenta_bancaria: "",
      numero_documento_pago: "",
      fecha_pago: "",
      monto_pagado: "",
    },
  });
  
    if (row.detalle_pago?.cuotas && row.detalle_pago?.cuotas.length > 0) {
   setCuotas(
  row.detalle_pago?.cuotas.map((d) => ({
    id: d.id, // 🔥 IMPORTANTE
    numero_cuota: d.numero_cuota,
     monto: d. monto,
    interes: d. interes || "",
   fecha_vencimiento: d.fecha_vencimiento || "",
   interes: d.interes || "",
   estado:d.estado || "",
  }))
);
  } else {
    setCuotas([]);
  }
  //  CARGAR DISTRIBUTIONS EXISTENTES
  if (row.distributions && row.distributions.length > 0) {
   setDistributions(
  row.distributions.map((d) => ({
    id: d.id, // 🔥 IMPORTANTE
    branch_id: d.branch_id,
    amount: d.amount,
    item: d.item || "",
    quantity: d.quantity || "",
    unit: d.unit || ""
  }))
);
  } else {
    setDistributions([]);
  }
  setOpenEditar(true);
};

const detallePago = egresoSeleccionado?.detalle_pago;
const cuota = detallePago?.cuotas ?? [];

  const handleCloseEdit = () => {
    setOpenEditar(false);
    setEgresoSeleccionado(null);
     setDistributions([]);
  };
  

const handleAgregarSucursal = () => {
    // Si es la primera vez que agregan
    if (distributions.length === 0) {
        setDistributions([
            {
                branch_id: egresoSeleccionado.branch_id, // usa la principal
                amount: "",
                item: "",
                quantity: "",
                unit: ""
            }
        ]);
    } else {
        // Si ya hay una, agrega vacía
        setDistributions([
            ...distributions,
            {
                branch_id: "",
                amount: "",
                item: "",
                quantity: "",
                unit: ""
            }
        ]);
    }
};
const handleDistributionChange = (index, field, value) => {
    const updated = [...distributions];
    updated[index][field] = value;
    setDistributions(updated);
};
const eliminarSucursal = (index) => {
    const updated = distributions.filter((_, i) => i !== index);
    setDistributions(updated);
};

 const totalDistribuidofinal = distributions.reduce(
    (sum, d) => sum + Number(d.amount || 0),
    0
);

  const handleEditarIngreso = async () => {
  if (!egresoSeleccionado) return;
   const totalDistribuido = distributions.reduce(
    (sum, d) => sum + Number(d.amount || 0),
    0
);

if (totalDistribuido > Number(egresoSeleccionado.amount)) {
    setErrorAlertOpen(true);
    setAlertMessage("La suma por sucursal supera el monto bruto");
    setEnviandoAlert(false);
    return;
}

  try {
    setEnviandoAlert(true);

    const formData = new FormData();

    // 🔹 CAMPOS NORMALES
    formData.append("date", egresoSeleccionado.date);
    formData.append("expense_category_id", egresoSeleccionado.expense_category_id);
    formData.append("description", egresoSeleccionado.description || "");
    formData.append("amount", egresoSeleccionado.amount);
    formData.append("branch_id", egresoSeleccionado.branch_id);
    formData.append("user_id", egresoSeleccionado.user_id);

    // 🔹 CAMPOS NUEVOS
    formData.append("campo", egresoSeleccionado.campo || "Descripción");
    formData.append("estado", egresoSeleccionado.estado || "");
    formData.append("origen_documento", egresoSeleccionado.origen_documento || "");
    formData.append("tipo_documento", egresoSeleccionado.tipo_documento || "");
    formData.append("folio", egresoSeleccionado.folio || "");
    formData.append("fecha_emision", egresoSeleccionado.fecha_emision || "");
    formData.append("monto_neto", egresoSeleccionado.monto_neto || 0);
    formData.append("iva", egresoSeleccionado.iva || 0);
    formData.append("monto_exento", egresoSeleccionado.monto_exento || 0);
    formData.append("tipo_retencion", egresoSeleccionado.tipo_retencion || "");
    formData.append("monto_retenido", egresoSeleccionado.monto_retenido || 0);
    formData.append("observaciones", egresoSeleccionado.observaciones || "");
     //  Distribuciones por sucursal
           distributions.forEach((dist, index) => {

  if (dist.id) {
    formData.append(`distributions[${index}][id]`, dist.id);
  }

  formData.append(`distributions[${index}][branch_id]`, dist.branch_id);
  formData.append(`distributions[${index}][amount]`, dist.amount);
  formData.append(`distributions[${index}][item]`, dist.item || "");
  formData.append(`distributions[${index}][quantity]`, dist.quantity || "");
  formData.append(`distributions[${index}][unit]`, dist.unit || "");
});

    // 🔹 PROVEEDOR
    if (egresoSeleccionado.proveedor_id) {
      formData.append("proveedor_id", egresoSeleccionado.proveedor_id);
    } else if (egresoSeleccionado.proveedor?.razon_social) {
      formData.append("proveedor[razon_social]", egresoSeleccionado.proveedor.razon_social);
      formData.append("proveedor[rut_proveedor]", egresoSeleccionado.proveedor.rut_proveedor || "");
    }

    // 🔹 DETALLE DE PAGO
    if (egresoSeleccionado.detalle_pago) {
      Object.entries(egresoSeleccionado.detalle_pago).forEach(([key, value]) => {
        formData.append(`detalle_pago[${key}]`, value ?? "");
      });
    }
    
    if (egresoSeleccionado.detalle_pago) {
  const detalle_pago = { ...egresoSeleccionado.detalle_pago, cuotas }; // usar cuotas editadas
  Object.entries(detalle_pago).forEach(([key, value]) => {
    if (key === "cuotas") {
      value.forEach((c, idx) => {
        Object.entries(c).forEach(([k, v]) => {
          formData.append(`detalle_pago[cuotas][${idx}][${k}]`, v ?? "");
        });
      });
    } else {
      formData.append(`detalle_pago[${key}]`, value ?? "");
    }
  });
}
    // 🔥 PDF (SOLO SI SE CAMBIÓ)
    if (egresoSeleccionado.documento_adjunto instanceof File) {
      formData.append("documento_adjunto", egresoSeleccionado.documento_adjunto);
    }

    

    for (let pair of formData.entries()) {
  console.log("FORMDATA:", pair[0], pair[1]);
}


    await editarEgresoRME(egresoSeleccionado.id, formData);

    setAlertMessage("Egreso actualizado correctamente ✅");
    setSuccessAlertOpen(true);
    refetch();
     refetchProveedores();
    handleCloseEdit();

  } catch (error) {
    console.error(error);
    setErrorAlertOpen(true);
    setAlertMessage(" Error en Egreso actualizado ");
  } finally {
    setEnviandoAlert(false);
  }
};


  useEffect(() => {
    refetch();
     refetchProveedores();
  }, [actualizarTabla]);


  const filas = egresosrme?.map((item) => ({
    id: item.id,
    date: item.date,
    amount: item.amount,
    iva: item.iva,
    monto_neto: item.monto_neto,
    monto_exento: item.monto_exento,
    estado:item.estado,
    description: item.description,
    monto_retenido:item.monto_retenido,
    // 🔹 Convertir objetos en strings
    expense_category: item.expense_category?.name ?? "",
    branch: item.branch?.name ?? "",
    user: item.user?.name ?? "",
    distributions: item.distributions ?? [],
    cuotas: item.detalle_pago?.cuotas ?? [],
    // Si necesitas el objeto completo para editar o eliminar
    raw: item,
  }));

  const calcularNeto = (bruto, ivaPorcentaje) => {
    if (!bruto || !ivaPorcentaje) return 0;
    return bruto / (1 + ivaPorcentaje / 100);
  };

  const calcularIvaMonto = (bruto, ivaPorcentaje) => {
    if (!bruto || !ivaPorcentaje) return 0;
    return bruto - calcularNeto(bruto, ivaPorcentaje);
  };
  const estadoColors = {
  Registrado: "#f0ad4e", // naranja
  Pagada: "#5cb85c",     // verde
  Anulado: "#d9534f",    // rojo
   Pendiente: "#eada06",
};


const DetalleRow = ({ row }) => (
  <Box
    sx={{
      width: "100%",
      maxHeight: 330, // altura máxima
      overflowY: "auto", // scroll vertical
      backgroundColor: "#f9fafb",
      p: 1,
      border: "1px solid #e0e0e0",
      borderRadius: 1,
      position: "absolute",
    }}
  >
    {/* DISTRIBUCIONES */}
    {row.distributions?.length > 0 && (
      <>
        <Typography sx={{ fontWeight: 600, mb: 1, fontFamily: "Poppins" }}>
          Distribuciones por Sucursal
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "200px 200px 200px 200px 200px",
            fontWeight: 600,
            borderBottom: "2px solid #ddd",
          }}
        >
          <span>Sucursal</span>
          <span>Monto</span>
          <span>Item</span>
          <span>Cantidad</span>
          <span>Unidad</span>
        </Box>
        {row.distributions.map((dist) => (
          <Box
            key={dist.id}
            sx={{
              display: "grid",
              gridTemplateColumns: "200px 200px 200px 200px 200px",
              py: 1,
              borderBottom: "1px solid #eee",
              alignItems: "center",
            }}
          >
            <span>{dist.branch?.name}</span>
            <span>{formatCLP(dist.amount)}</span>
            <span>{dist.item}</span>
            <span>{dist.quantity}</span>
            <span>{dist.unit}</span>
          </Box>
        ))}
      </>
    )}

    {/* CUOTAS */}
    {row.cuotas?.length > 0 && (
      <>
        <Typography sx={{ fontWeight: 600, mt: 2, mb: 1, fontFamily: "Poppins" }}>
          Detalle de Cuotas
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "100px 150px 150px 200px 120px",
            fontWeight: 600,
            borderBottom: "2px solid #ddd",
          }}
        >
          <span>N° Cuota</span>
          <span>Monto</span>
          <span>Interés (%)</span>
          <span>Fecha Vencimiento</span>
          <span>Estado</span>
        </Box>
        {row.cuotas.map((cuota, idx) => {
          const color = estadoColors[cuota.estado] || "#ccc"; // color según estado
          return (
            <Box
              key={idx}
              sx={{
                display: "grid",
                gridTemplateColumns: "100px 150px 150px 200px 120px",
                borderBottom: "1px solid #eee",
                alignItems: "center",
                py: 0.5,
              }}
            >
              <span>{cuota.numero_cuota}</span>
              <span>{formatCLP(cuota.monto)}</span>
              <span>{cuota.interes}</span>
              <span>{cuota.fecha_vencimiento || cuota.due_date}</span>
              <Box
  onClick={async () => {
    const nuevoEstado =
      cuota.estado === "Pagada" ? "Pendiente" : "Pagada";

    try {
      await editarCuota(cuota.id, nuevoEstado);
      refetch()
      actualizarTabla(); // 🔥 refresca egresos

    } catch (error) {
      console.error(error);
    }
  }}
  sx={{
    width: "100px",
    textAlign: "center",
    borderRadius: 1,
    color: "#fff",
    backgroundColor: color,
    fontWeight: 600,
    px: 1,
    py: 0.5,
    alignSelf: "center",
    cursor: "pointer",
    transition: "0.2s",
    "&:hover": {
       transform: "scale(1.05)",
      opacity: 0.8,
    },
  }}
>
  {cuota.estado}
</Box>
            </Box>
          );
        })}
      </>
    )}
  </Box>
);
  // 🔹 Columnas del DataGrid
  const columns = [
    {
    field: "expand",
    headerName: "",
    width: 60,
    sortable: false,
    renderCell: (params) => {
      if (params.row.isDetail) return null;

       const hasDistributions =
      params.row.distributions && params.row.distributions.length > 0;

    const hasCuotas = params.row.cuotas && params.row.cuotas.length > 0;

    if (!hasDistributions && !hasCuotas) return null;

      return (
        <IconButton
          size="small"
          onClick={() =>
            setExpandedRowId(
              expandedRowId === params.row.id ? null : params.row.id
            )
          }
        >
         {hasCuotas ? (
  // Si tiene cuotas, mostramos solo la tarjeta
  <CreditCardIcon
    style={{
      marginLeft: 4,
      color: "#2a8d74",
      fontWeight: "bold",
    }}
  />
) : (
  // Si no tiene cuotas, mostramos + o − según expandedRowId
  expandedRowId === params.row.id ? (
    <RemoveIcon style={{ color: "#2a8d74", fontWeight: "bold" }} />
  ) : (
    <AddIcon style={{ color: "#2a8d74", fontWeight: "bold" }} />
  )
)}
        </IconButton>
      );
    },
  },

  {
    field: "date",
    headerName: "Fecha",
    width: 120,
     colSpan: (params) => {
  if (params?.row?.isDetail) {
    return 13;
  }
  return 1;
},
   renderCell: (params) => {
  if (!params.row.isDetail && expandedRowId === params.row.id) {
    return <DetalleRow row={params.row} />;
  }
  return params.value;
}
  },

    {
      field: "user",
      headerName: "Administrador",
      width: 180,
       renderCell: (params) =>
      params.row.isDetail ? null : params.value,
    },
    {
      field: "branch",
      headerName: "Sucursal",
      width: 150,
       renderCell: (params) =>
      params.row.isDetail ? null : params.value,
    },
    {
      field: "expense_category",
      headerName: "Categoría",
      width: 180,
       renderCell: (params) =>
      params.row.isDetail ? null : params.value,
    },
    {
  field: "estado",
  headerName: "Estado",
  width: 180,
  renderCell: (params) => {
     if (params.row.isDetail) return null;
    let color = "#ccc"; // default gris

    switch (params.value) {
      case "Registrado":
        color = "#f0ad4e"; // naranja
        break;
      case "Pagado":
        color = "#5cb85c"; // verde
        break;
      case "Anulado":
        color = "#d9534f"; // rojo
        break;
      default:
        color = "#ccc";
    }

    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        {/* Cuadrado de color */}
        <Box
          sx={{
           width:100,
           textAlign:'center',
           
           color:'#fff',
            borderRadius: 1,
            backgroundColor: color,
          }}
        >
        <span>{params.value}</span>
        </Box>
      </Box>
    );
  },
},
    {
      field: "amount",
      headerName: "Monto Bruto",
      width: 150,
        renderCell: (params) =>
      params.row.isDetail ? null : formatCLP(params.row.amount || "0"),
    },
    {
      field: "iva",
      headerName: "IVA",
      width: 150,
      renderCell: (params) => params.row.isDetail ? null : formatCLP(
        calcularIvaMonto(
          Number(params.row.amount),
          Number(params.row.iva) || "0"
        )
      )
    },

    {
      field: "monto_neto",
      headerName: "Monto Neto",
      width: 150,
      renderCell: (params) => params.row.isDetail ? null : formatCLP(params.row.monto_neto || "0"), // ✅ aquí monto_neto
    },
    {
      field: "monto_exento",
      headerName: "Monto Exento",
      width: 150,
      renderCell: (params) =>
       params.row.isDetail ? null : formatCLP(Number(params.row.monto_exento) || "0")
     
    },
      {
      field: "monto_retenido",
      headerName: "Monto Retenido",
      width: 150,
      renderCell: (params) =>
      params.row.isDetail ? null :  formatCLP(Number(params.row.monto_retenido) || "0")
      
    },
    {
      field: "description",
      headerName: "Descripción",
      width: 250,
     renderCell: (params) =>
      params.row.isDetail ? null : params.value,
  },
    {
      field: "acciones",
      headerName: "Acción",
      width: 180,
      renderCell: (params) => {
           if (params.row.isDetail) return null;
        return (
          <Box
            sx={{
              display: "flex",
              gap: 1,
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* Botón Ver Detalle */}
            <Tooltip title="Ver Detalle">
              <IconButton onClick={() => {
                setEgresoSeleccionado(params.row.raw);
                setOpenDetalle(true);
              }}
                sx={{ background: '#28b6c6ff' }}>
                <BsPersonVcard style={{ color: '#fff' }} />
              </IconButton>

            </Tooltip>

            {/* Botón Editar */}
            <Tooltip title="Editar">
              <button
                className="edit-button"
                onClick={() => handleOpenEdit(params.row.raw)}
              >
                <svg className="edit-svgIcon" viewBox="0 0 512 512">
                  <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32z" />
                </svg>
              </button>
            </Tooltip>

            {/* Botón Eliminar */}
            <Tooltip title="Eliminar">
              <button
                className="delete-button"
                onClick={() => {
                  setEgresoSeleccionado(params.row.raw);
                  setOpenEliminar(true);
                }}
              >
                <FaTrashCan className="delete-svgIcon" />
              </button>
            </Tooltip>
          </Box>
        );
      },
    },
  ];

  const montoBruto = Number(egresoSeleccionado?.amount) || 0;
  const montoPagado = Number(egresoSeleccionado?.detalle_pago?.monto_pagado) || 0;

  const saldoPendiente = montoBruto - montoPagado;


const calcularRetencion = () => {
    const bruto = Number(egresoSeleccionado.amount) || 0;

    if (bruto > 0) {
        const retenido = Math.round(bruto * 0.1525);
        const netoFinal = bruto - retenido;

        setEgresoSeleccionado({
            ...egresoSeleccionado,
            monto_retenido: retenido,
            monto_neto: netoFinal
        });
    }
};
const filasConDetalle = [];

(filas || []).forEach((row) => {
    filasConDetalle.push(row);

    if (expandedRowId === row.id) {
        filasConDetalle.push({
            id: `${row.id}-detail`,
            isDetail: true,
            distributions: row.distributions,
            cuotas: row.cuotas,
        });
    }
});

const sumaCuotas = cuotas.reduce(
  (acc, c) => acc + Number(c.monto || 0),
  0
);

const hayDiferencia = cuotas.length > 0 && 
  sumaCuotas !== Number(egresoSeleccionado?.amount);
  return (
    <>
      <Box sx={{ mt: 5, mb: 5 }}>
        <Stack direction="row" spacing={2} sx={{ mb: 2 }}>

          {/* FILTRO POR MES */}
          {/* FILTRO POR MES */}
          <FormControl sx={{ ...InputBuscador, width: 200 }}>
            <InputLabel>Mes</InputLabel>
            <Select
              label="Mes"
              value={filtroMes}
              onChange={(e) => setFiltroMes(e.target.value)}
            >
              <MenuItem value="">Todos</MenuItem>

              {[
                { num: "01", nombre: "Enero" },
                { num: "02", nombre: "Febrero" },
                { num: "03", nombre: "Marzo" },
                { num: "04", nombre: "Abril" },
                { num: "05", nombre: "Mayo" },
                { num: "06", nombre: "Junio" },
                { num: "07", nombre: "Julio" },
                { num: "08", nombre: "Agosto" },
                { num: "09", nombre: "Septiembre" },
                { num: "10", nombre: "Octubre" },
                { num: "11", nombre: "Noviembre" },
                { num: "12", nombre: "Diciembre" },
              ].map((m) => (
                <MenuItem key={m.num} value={m.num}>
                  {m.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>


          {/* FILTRO POR AÑO */}
          <FormControl sx={{ ...InputBuscador, width: 200 }}>
            <InputLabel>Año</InputLabel>
            <Select
              label="Año"
              value={filtroAno}
              onChange={(e) => setFiltroAno(e.target.value)}
            >
              <MenuItem value="">Todos</MenuItem>
              {[2025, 2026].map((a) => (
                <MenuItem key={a} value={String(a)}>
                  {a}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl sx={{ ...InputBuscador, width: 220 }}>
  <InputLabel>Tipo Fecha</InputLabel>

  <Select
    value={tipoFecha}
    label="Tipo Fecha"
    onChange={(e) => setTipoFecha(e.target.value)}
  >
    <MenuItem value="date">
      Fecha Registro
    </MenuItem>

    <MenuItem value="fecha_pago">
      Fecha Pago
    </MenuItem>
  </Select>
</FormControl>

  <FormControl sx={{ ...InputBuscador, width: 220 }}>
  <InputLabel>Categoria</InputLabel>
 <Select
    value={filtroCategoria}
    label="Categoría"
    onChange={(e) => setFiltroCategoria(e.target.value)}
>
    <MenuItem value="">Todas</MenuItem>

    {categorias.map((cat) => (
        <MenuItem key={cat.id} value={cat.id}>
            {cat.name}
        </MenuItem>
    ))}
</Select>
</FormControl>

        </Stack>


      </Box>
      <Box sx={{ height: 600, width: "100%", mt: 2 }}>
        {loadingEgresos ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "300px",
              gap: 2,
              position: "relative"
            }}
          >
            {/* Círculo */}
            <CircularProgress size={90} thickness={4} sx={{ color: '#6fd385ff' }} />

            {/* Imagen centrada encima del círculo */}
            <Box
              component="img"
              src={Logocolor}
              alt="Logo"
              sx={{
                width: "55px",
                height: "55px",
                position: "absolute",
                top: "90px"
              }}
            />

            <Typography sx={{ fontFamily: "Poppins", fontSize: "18px", mt: 2 }}>
              Cargando...
            </Typography>
          </Box>
        ) : (
          <DataGrid
            rows={filasConDetalle}
            columns={columns}
            getRowId={(row) => row.id}
         getDetailPanelContent={({ row }) => <DetalleRow row={row} />}
  getDetailPanelHeight={() => 300} // altura fija o dinámica
            disableRowSelectionOnClick
            slots={{ noRowsOverlay: DiseñoDataGrid }}
            sx={{
              fontFamily: 'Poppins, sans-serif',
              '& .MuiDataGrid-columnHeaders': {
                color: '#113e21ff',
                fontWeight: 600,
                textTransform: 'capitalize',
              },
              '& .MuiDataGrid-cell': {
                textTransform: 'capitalize',
              },
            }}
          />
        )}
      </Box>

      {/* Modal Eliminar */}
      <Dialog open={openEliminar} onClose={() => setOpenEliminar(false)}>
        <DialogTitle>Eliminar Egreso</DialogTitle>
        <DialogContent>
          ¿Seguro que deseas eliminar este egreso?
          <br />
          <strong>{egresoSeleccionado?.description}</strong>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenEliminar(false)}>Cancelar</Button>
          <Button
            color="error"
            onClick={async () => {
              await eliminarEgresoRME(egresoSeleccionado.id);
              setOpenEliminar(false);
              refetch();
            }}
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>

      <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: "center" }}>
            <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
            <p className="alert-text">{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: "center" }}>
            <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
            <p className="alert-text">{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      <Modal open={enviandoAlert}>
        <Box sx={modalStyle}>
          <section style={{ textAlign: "center", padding: "1rem" }}>
            <CircularProgress style={{ color: "#2a8d74" }} />
            <p className="alert-text">Procesando solicitud...</p>
          </section>
        </Box>
      </Modal>

      <Dialog open={openEditar} onClose={handleCloseEdit} maxWidth="sm" fullWidth>
        <DialogTitle>Editar Egreso RME</DialogTitle>

        <DialogContent dividers>
          {egresoSeleccionado && (
            <Box display="flex" flexDirection="column" gap={2}>

              {/* SELECT CATEGORÍA */}

              <Box display="flex" flexDirection="column" gap={2}>

                {/* TODO TU FORMULARIO AQUÍ */}
                <FormControl fullWidth sx={Input}>
                  <InputLabel>Tipo</InputLabel>
                  <Select
                    value={egresoSeleccionado.expense_category_id ?? ""}
                    label="Tipo"
                    onChange={(e) =>
                      setEgresoSeleccionado({
                        ...egresoSeleccionado,
                        expense_category_id: Number(e.target.value),
                      })
                    }
                  >
                    {categorias?.map((cat) => (
                      <MenuItem key={cat.id} value={cat.id}>
                        {cat.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* resto del formulario */}
              </Box>


              <FormControl fullWidth sx={Input}>
                <InputLabel>Estado</InputLabel>
                <Select
                  value={egresoSeleccionado.estado}
                  label="Estado"
                  onChange={(e) =>
                    setEgresoSeleccionado({
                      ...egresoSeleccionado,
                      estado: e.target.value
                    })
                  }
                >
                  <MenuItem value="Registrado">Registrado</MenuItem>
                  <MenuItem value="Pagado">Pagado</MenuItem>
                  <MenuItem value="Anulado">Anulado</MenuItem>
                </Select>
              </FormControl>

              <Box>
                {/* SELECT SUCURSAL */}
                <FormControl fullWidth sx={Input}>
                  <InputLabel>Sucursal</InputLabel>
                  <Select
                    value={egresoSeleccionado.branch_id}
                    label="Sucursal"
                    onChange={(e) =>
                      setEgresoSeleccionado({
                        ...egresoSeleccionado,
                        branch_id: Number(e.target.value),
                      })
                    }
                  >
                    {sucursales?.map((s) => (
                      <MenuItem key={s.id} value={s.id}>
                        {s.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* FECHA */}
                <TextField
                  label="Fecha"
                  type="date"
                  value={egresoSeleccionado.date}
                  onChange={(e) =>
                    setEgresoSeleccionado({
                      ...egresoSeleccionado,
                      date: e.target.value,
                    })
                  }
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  sx={{ ...inputFechaGrande, mt: 2, mb: 2 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <CalendarToday />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* DESCRIPCIÓN */}
                <TextField
                  label="Descripción"
                  value={egresoSeleccionado.description}
                  onChange={(e) =>
                    setEgresoSeleccionado({
                      ...egresoSeleccionado,
                      description: e.target.value,
                    })
                  }
                  fullWidth
                  multiline
                  rows={2}
                  sx={InputDescripcion}
                />

              </Box>
              <Box sx={{ borderRadius: 1, border: '1px solid #585857', p: 2 }}>
                <Typography variant="subtitle1" sx={SubTitulodos}>  Información del Documento Tributario</Typography>
                <Box mt={3}>
        
                  <Box mt={2}>
                    <FormControl fullWidth sx={Input}>
                      <InputLabel>Origen del Documento</InputLabel>
                      <Select
                        value={egresoSeleccionado.origen_documento}
                        label="origen documento"
                        onChange={(e) =>
                          setEgresoSeleccionado({
                            ...egresoSeleccionado,
                            origen_documento: e.target.value
                          })
                        }
                      >
                        <MenuItem value="Manual">Manual</MenuItem>
                        <MenuItem value="Emitido">Emitido</MenuItem>
                         <MenuItem value="Recibido">Recibido</MenuItem>

                      </Select>
                    </FormControl>
                  </Box>
                  <Box mt={2}>
                    <FormControl fullWidth sx={Input}>
                      <InputLabel>Tipo Documento</InputLabel>
                      <Select
                        value={egresoSeleccionado.tipo_documento}
                        label="Tipo Documento"
                        onChange={(e) =>
                          setEgresoSeleccionado({
                            ...egresoSeleccionado,
                            tipo_documento: e.target.value,
                          })
                        }
                      >
                        <MenuItem value="Factura Electrónica">Factura Electrónica</MenuItem>
                        <MenuItem value="Factura Exenta">Factura Exenta</MenuItem>
                        <MenuItem value="Boleta Electrónica">Boleta Electrónica</MenuItem>
                        <MenuItem value="Boleta Exenta">Boleta Exenta</MenuItem>
                        <MenuItem value="Boleta Honorarios">Boleta Honorarios</MenuItem>
                        <MenuItem value="Nota de Crédito Electrónica">Nota de Crédito</MenuItem>
                        <MenuItem value="Nota de Débito Electrónica">Nota de Débito</MenuItem>
                        <MenuItem value="Liquidación">Liquidación</MenuItem>
                        <MenuItem value="Guía de Despacho">Guía de Despacho</MenuItem>
                        <MenuItem value="Orden de Compra">Orden de Compra</MenuItem>

                        {/* ⭐ ESTA ES LA OPCIÓN QUE ACTIVA EL INPUT */}
                        <MenuItem value="Otros">Otros</MenuItem>
                      </Select>
                    </FormControl>

                    {egresoSeleccionado.tipo_documento === "Otros" && (
                      <TextField
                        label="Especificar documento"
                        fullWidth
                        sx={{ mt: 2, ...Input }}
                        value={egresoSeleccionado.tipo_documento}
                        onChange={(e) =>
                          setEgresoSeleccionado({
                            ...egresoSeleccionado,
                            tipo_documento: e.target.value,
                          })
                        }
                      />
                    )}
                  </Box>
                  <Box mt={2}>
                    <TextField
                      label="Folio"
                      value={egresoSeleccionado.folio}
                      onChange={(e) => setEgresoSeleccionado({ ...egresoSeleccionado, folio: e.target.value })}
                      fullWidth
                      sx={Input}
                    />


                  </Box>
                  <Box mt={2}>
                    <TextField
                      label="Fecha de Emisión"
                      type="date"
                      value={egresoSeleccionado.fecha_emision}
                      onChange={(e) => setEgresoSeleccionado({ ...egresoSeleccionado, fecha_emision: e.target.value })}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      sx={{ ...inputFechaGrande, mt: 2, mb: 2 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <CalendarToday />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                </Box>
              </Box>
              <Box>
                <Box sx={{ borderRadius: 1, border: "1px solid #585857", p: 2 }}>
                  <Typography variant="subtitle1" sx={SubTitulodos}>
                    Información del Proveedor
                  </Typography>

                  <Box mt={2}>
                    <FormControl fullWidth sx={Input}>
                      <InputLabel>Proveedor</InputLabel>
                      <Select         
                        value={egresoSeleccionado.proveedor_id || ""}
                        label="Proveedor"
                        onChange={(e) => {
                          const value = e.target.value;

                          setEgresoSeleccionado((prev) => ({
                            ...prev,
                            proveedor_id: value || null,
                            proveedor: value
                              ? null // ← si elige existente, NO crear nuevo
                              : { razon_social: "", rut_proveedor: "" },
                          }));
                        }}
                        fullWidth
                      >
                        <MenuItem value="">Sin proveedor</MenuItem>

                        {proveedores?.map((p) => (
                          <MenuItem key={p.id} value={p.id}>
                            {p.razon_social} — {p.rut_proveedor}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    {/* ✔ Mostrar formulario solo si NO seleccionó un proveedor existente */}
                    {!egresoSeleccionado.proveedor_id && (
                      <Box mt={2}>
                        <Typography variant="subtitle1" sx={SubTitulodos}>
                          Nuevo Proveedor
                        </Typography>
                        <Box mt={1}>
                          <TextField
                            label="Razón Social"
                            value={egresoSeleccionado.proveedor?.razon_social || ""}
                            onChange={(e) =>
                              setEgresoSeleccionado({
                                ...egresoSeleccionado,
                                proveedor: {
                                  ...egresoSeleccionado.proveedor,
                                  razon_social: e.target.value,
                                },
                              })
                            }
                            fullWidth
                            sx={Input}
                          />
                        </Box>
                        <Box mt={1}>
                          <TextField
                            label="RUT del Proveedor"
                            value={egresoSeleccionado.proveedor?.rut_proveedor || ""}   // ← EL VALUE SIGUE IGUAL
                            onChange={(e) => {
                              const rutFormateado = FormatRut(e.target.value); // ← FORMATEO AQUÍ

                              setEgresoSeleccionado({
                                ...egresoSeleccionado,
                                proveedor: {
                                  ...egresoSeleccionado.proveedor,
                                  rut_proveedor: rutFormateado, // ← SE GUARDA FORMATEADO
                                },
                              });
                            }}
                            fullWidth
                            sx={Input}
                          />
                        </Box>

                      </Box>
                    )}
                  </Box>
                </Box>

              </Box>


              <Box sx={{ borderRadius: 1, border: "1px solid #585857", p: 2 }}>
                <Typography variant="subtitle1" sx={SubTitulodos}>
                  Información del Monto
                </Typography>

                <Box mt={2}>

                  {/* Monto Bruto */}
   <TextField
  label="Monto"
  value={formatCLP(egresoSeleccionado.amount || 0)}
  onChange={(e) => {
    // Solo permitir cambios manuales si NO hay cuotas
   

    const cleanValue = Number(e.target.value.replace(/\D/g, ""));
    const ivaPercent = egresoSeleccionado.iva
      ? Number(egresoSeleccionado.iva) / 100
      : 0;

    let neto =
      ivaPercent > 0
        ? Math.round(cleanValue / (1 + ivaPercent))
        : cleanValue;

    let ivaCalc = cleanValue - neto;

    let retenido = 0;
    if (aplicarRetencion) {
      retenido = Math.round(cleanValue * 0.1525);
      neto = cleanValue - retenido;
    }

    setEgresoSeleccionado({
      ...egresoSeleccionado,
      amount: cleanValue,
      monto_neto: neto,
      monto_retenido: retenido,
      iva: ivaPercent > 0 ? ivaCalc : 0
    });
  }}
  fullWidth
  sx={Input}
  
/>

{hayDiferencia && (
  <Box mt={2}>
    <Typography color="warning.main" sx={SubTitulodos}>
      La suma de cuotas es {formatCLP(sumaCuotas)}.
    </Typography>

    <Button
      variant="contained"
      color="warning"
      sx={{ mt: 1, mb:3 }}
      onClick={() => {
        const nuevoAmount = sumaCuotas;

        const ivaPercent = egresoSeleccionado.iva
          ? Number(egresoSeleccionado.iva) / 100
          : 0;

        let neto =
          ivaPercent > 0
            ? Math.round(nuevoAmount / (1 + ivaPercent))
            : nuevoAmount;

        let ivaCalc = nuevoAmount - neto;

        let retenido = 0;
        if (aplicarRetencion) {
          retenido = Math.round(nuevoAmount * 0.1525);
          neto = nuevoAmount - retenido;
        }

        setEgresoSeleccionado(prev => ({
          ...prev,
          amount: nuevoAmount,
          monto_neto: neto,
          monto_retenido: retenido,
          iva: ivaPercent > 0 ? ivaCalc : 0
        }));
      }}
    >
      Confirmar cambio de monto
    </Button>
  </Box>
)}

                  {/* IVA */}
                  <Box mt={1} mb={1}>
                    <TextField
                      label="IVA % (19 = 19%)"
                      value={egresoSeleccionado.iva}
                      onChange={(e) => {
                        const cleanValue = Number(e.target.value.replace(/\D/g, "")); // solo 19, 10, etc.

                        const ivaPercent = cleanValue / 100;
                        const amount = Number(egresoSeleccionado.amount);

                        // Recalcular Neto
                        const neto = ivaPercent > 0 ? Math.round(amount / (1 + ivaPercent)) : amount;
                        const ivaCalc = amount - neto;

                        setEgresoSeleccionado({
                          ...egresoSeleccionado,
                          iva: cleanValue,
                          monto_neto: neto,
                        });
                      }}
                      fullWidth
                      sx={Input}
                    />
                  </Box>

                  {/* Monto Neto */}
                <TextField
  label="Monto Neto"
  value={formatCLP(egresoSeleccionado.monto_neto)}
  onChange={(e) => {
    const cleanValue = Number(e.target.value.replace(/\D/g, "")) || 0;

    // Guardar solo el neto, sin tocar el monto bruto
    setEgresoSeleccionado({
      ...egresoSeleccionado,
      monto_neto: cleanValue
    });
  }}
  fullWidth
  sx={Input}
/>

{/* Opcional: botón para recalcular bruto desde neto */}
<Button
  variant="outlined"
  sx={{ mt: 1, mb: 2 }}
  onClick={() => {
    const ivaPercent = egresoSeleccionado.iva ? Number(egresoSeleccionado.iva) / 100 : 0;
    const neto = Number(egresoSeleccionado.monto_neto) || 0;
    const amount = Math.round(neto * (1 + ivaPercent));
    const ivaCalc = amount - neto;

    setEgresoSeleccionado(prev => ({
      ...prev,
      amount,
      iva: ivaCalc
    }));
  }}
>
  Recalcular Bruto desde Neto
</Button>

                  {/* Monto Exento */}
                  <Box mt={1} mb={1}>
                    <TextField
                      label="Monto Exento"
                      value={formatCLP(egresoSeleccionado.monto_exento)}
                      onChange={(e) => {
                        const cleanValue = e.target.value.replace(/\D/g, "");
                        setEgresoSeleccionado({
                          ...egresoSeleccionado,
                          monto_exento: cleanValue,
                        });
                      }}
                      fullWidth
                      sx={Input}
                    />
                  </Box>

                </Box>
              </Box>
                  <Box sx={{ borderRadius: 1, border: "1px solid #585857", p: 2 }}>
                <Typography variant="subtitle1" sx={SubTitulodos}>
                  Información de retención
                </Typography>
                  <FormControlLabel
                    control={
                        <Switch
                            checked={aplicarRetencion}
                            onChange={(e) => {
                                const checked = e.target.checked;
                                setAplicarRetencion(checked);
                
                                if (checked) {
                                    calcularRetencion();
                                } else {
                                    setEgresoSeleccionado({
                                        ...egresoSeleccionado,
                                        monto_retenido: 0,
                                        tipo_retencion: ""
                                    });
                                }
                            }}
                        />
                    }
                    label="¿Aplicar Retención 15,25%?" 
                    sx={{
                        "& .MuiFormControlLabel-label": {
                            fontFamily: "Poppins",
                            color: "#22324A",
                            fontWeight: 500,
                            fontSize: "0.95rem"
                        }
                    }}
                />
                 {aplicarRetencion && (
    <>
                <TextField
                  label="Tipo de Retención"
                  value={egresoSeleccionado.tipo_retencion}
                  onChange={(e) =>
                    setEgresoSeleccionado({
                      ...egresoSeleccionado,
                      tipo_retencion: e.target.value,
                    })
                  }
                  fullWidth
                  sx={{ ...Input, mt: 1, mb: 1 }}
                />

                {/* Monto Retenido con formateo CLP */}
                <TextField
                  label="Monto Retenido"
            value={formatCLP(egresoSeleccionado.monto_retenido)}
            fullWidth
            sx={Input}
            InputProps={{
                readOnly: true // 👈 importante
            }}
                />
                </>
                 )}
              </Box>
                <Box sx={{ borderRadius: 1, border: "1px solid #585857", p: 2 }}>
                  <Typography variant="subtitle1" sx={SubTitulodos}>
                      Información del Monto por sucursal
                  </Typography>
              
                  <Button
                      variant="outlined"
                      startIcon={<AddIcon />}
                     onClick={handleAgregarSucursal}
                      sx={buttonGuardar}
                  >
                      Agregar sucursal
                  </Button>
              
                  {distributions.map((dist, index) => (
                      <Box key={index} sx={{ mt: 2, border: "1px solid #ccc", p: 2, borderRadius: 1 }}>
              
                          {/* Sucursal */}
                          <FormControl fullWidth sx={Input}>
                              <InputLabel>Sucursal</InputLabel>
                              <Select
                                  value={dist.branch_id}
                                  label="Sucursal"
                                  onChange={(e) =>
                                      handleDistributionChange(index, "branch_id", Number(e.target.value))
                                  }
                              >
                                  {sucursales?.map((s) => (
                                      <MenuItem key={s.id} value={s.id}>
                                          {s.name}
                                      </MenuItem>
                                  ))}
                              </Select>
                          </FormControl>
              
                          {/* Monto */}
                         
                          <Box mt={1} mb={1}>
                  <TextField
                      fullWidth
                      label="Monto"
                      sx={Input}
                      value={formatCLP(dist.amount)}
                      onChange={(e) => {
                          // Quitamos todo lo que no sea número
                          const rawValue = e.target.value.replace(/\D/g, "");
                          handleDistributionChange(index, "amount", rawValue);
                      }}
                  />
              </Box>
              
                           <Box mt={1} mb={1}>
                          <TextField
                              fullWidth
                              label="Item"
                              sx={Input}
                              value={dist.item}
                              onChange={(e) =>
                                  handleDistributionChange(index, "item", e.target.value)
                              }
                          />
                          </Box>
              
                            <Box mt={1} mb={1}>
                          <TextField
                              fullWidth
                              label="Cantidad"
                              type="number"
                              sx={Input}
                              value={dist.quantity}
                              onChange={(e) =>
                                  handleDistributionChange(index, "quantity", e.target.value)
                              }
                          />
                          </Box>
              
                            <Box mt={1} mb={1}>
                          <TextField
                              fullWidth
                              label="Unidad"
                              sx={Input}
                              value={dist.unit}
                              onChange={(e) =>
                                  handleDistributionChange(index, "unit", e.target.value)
                              }
                          />
                          </Box>
              
                          <Button
                              color="error"
                              onClick={() => eliminarSucursal(index)}
                              sx={buttonCancelar}
                          >
                              Eliminar
                          </Button>
                      </Box>
                  ))}
                  <Typography sx={{...SubTitulodos,mt:3}}>
                  Total distribuido: {formatCLP(totalDistribuidofinal)}
              </Typography>
              </Box>

             <Box sx={{ borderRadius: 1, border: "1px solid #585857", p: 2 }}>
                <Typography variant="subtitle1" sx={SubTitulodos}>
                  Información del detalle de pago
                </Typography>

                <Box>
                  <FormControl fullWidth sx={{ ...Input, mt: 1, mb: 1 }}>
                    <InputLabel>Medio de Pago</InputLabel>
                    <Select
                      label="Medio de Pago"
                      value={egresoSeleccionado.detalle_pago?.medio_pago}
                      onChange={(e) =>
                        setEgresoSeleccionado({
                          ...egresoSeleccionado,
                          detalle_pago: {
                            ...egresoSeleccionado.detalle_pago,
                            medio_pago: e.target.value,
                            medio_pago_personalizado:
                              e.target.value === "Otro medio de pago" ? "" : null,
                          },
                        })
                      }
                    >
                      <MenuItem value="Transferencia">Transferencia</MenuItem>
                      <MenuItem value="Cheque">Cheque</MenuItem>
                      <MenuItem value="Efectivo">Efectivo</MenuItem>
                      <MenuItem value="Débito">Débito</MenuItem>
                      <MenuItem value="Crédito">Crédito</MenuItem>
                      <MenuItem value="Otro medio de pago">Otro medio de pago</MenuItem>
                    </Select>
                  </FormControl>

                  {egresoSeleccionado.detalle_pago?.medio_pago === "Otro medio de pago" && (
                    <TextField
                      label="Especifique el medio de pago"
                      fullWidth
                      sx={{ ...Input, mt: 1 }}
                      value={egresoSeleccionado.detalle_pago?.medio_pago_personalizado || ""}
                      onChange={(e) =>
                        setEgresoSeleccionado({
                          ...egresoSeleccionado,
                          detalle_pago: {
                            ...egresoSeleccionado.detalle_pago,
                            medio_pago_personalizado: e.target.value,
                          },
                        })
                      }
                    />
                  )}

                </Box>
                 {egresoSeleccionado.detalle_pago?.medio_pago === "Otro medio de pago" && (
    <TextField
      label="Especifique el medio de pago"
      fullWidth
      sx={{ ...Input, mt: 1 }}
      value={egresoSeleccionado.detalle_pago?.medio_pago_personalizado || ""}
      onChange={(e) =>
        setEgresoSeleccionado({
          ...egresoSeleccionado,
          detalle_pago: {
            ...egresoSeleccionado.detalle_pago,
            medio_pago_personalizado: e.target.value,
          },
        })
      }
    />
  )}


 {egresoSeleccionado.detalle_pago?.medio_pago === "Crédito" && (
  <Box sx={{ border: "1px solid #aaa", borderRadius: 1, p: 2, mt: 2, mb:4 }}>
    <Typography variant="subtitle1" sx={SubTitulodos}>
      Detalle de Cuotas
    </Typography>

   
    <TextField
      label="Día de vencimiento"
      type="number"
      value={egresoSeleccionado.detalle_pago?.dia_vencimiento || ""}
      onChange={(e) =>
        setEgresoSeleccionado({
          ...egresoSeleccionado,
          detalle_pago: {
            ...egresoSeleccionado.detalle_pago,
            dia_vencimiento: e.target.value,
          },
        })
      }
      fullWidth
      sx={{ ...Input, mt: 1, mb: 1 }}
    />
   <FormControl fullWidth sx={{ ...Input, mt: 1, mb: 1 }}>
                                          <InputLabel>Año Inicial</InputLabel>
                                          <Select
                                              value={egresoSeleccionado.detalle_pago.anio_inicial ?? new Date().getFullYear()}
                                              onChange={(e) =>
                                                  setEgresoSeleccionado({
                                                      ...egresoSeleccionado,
                                                      detalle_pago: {
                                                          ...egresoSeleccionado.detalle_pago,
                                                          anio_inicial: Number(e.target.value),
                                                      },
                                                  })
                                              }
                                          >
                                              {Array.from({ length: 10 }, (_, i) => {
                                                  const year = new Date().getFullYear() - 5 + i;
                                                  return <MenuItem key={year} value={year}>{year}</MenuItem>;
                                              })}
                                          </Select>
                                      </FormControl>
  
    <FormControl fullWidth sx={{ ...Input, mt: 1, mb: 1 }}>
      <InputLabel>Mes Inicial</InputLabel>
      <Select
        value={egresoSeleccionado.detalle_pago?.mes_inicial ?? new Date().getMonth()}
        onChange={(e) => {
          const mesInicial = Number(e.target.value);
          setEgresoSeleccionado({
            ...egresoSeleccionado,
            detalle_pago: { ...egresoSeleccionado.detalle_pago, mes_inicial: mesInicial },
          });
        }}
      >
        {["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"].map((mes, idx) => (
          <MenuItem key={idx} value={idx}>{mes}</MenuItem>
        ))}
      </Select>
    </FormControl>

    <TextField
      label="Monto Total"
      value={formatCLP(egresoSeleccionado.detalle_pago?.monto_total || 0)}
      onChange={(e) => {
        const montoTotal = Number(e.target.value.replace(/\D/g, "")) || 0;
        const updatedDetalle = { ...egresoSeleccionado.detalle_pago, monto_total: montoTotal };

        // Recalcular cuotas proporcionalmente
        const updatedCuotas = (egresoSeleccionado.detalle_pago.cuotas || []).map(c => ({
          ...c,
          monto: ((c.monto / (egresoSeleccionado.detalle_pago.monto_total || 1)) * montoTotal).toFixed(0)
        }));

        setEgresoSeleccionado({
          ...egresoSeleccionado,
          detalle_pago: {
            ...updatedDetalle,
            cuotas: updatedCuotas
          },
        });

        setCuotas(updatedCuotas);
      }}
      fullWidth
      sx={{ ...Input, mt: 1, mb: 1 }}
    />

    <TextField
      label="Interés (%)"
      value={egresoSeleccionado.detalle_pago?.interes || ""}
      onChange={(e) => {
        const interes = e.target.value;
        setEgresoSeleccionado({
          ...egresoSeleccionado,
          detalle_pago: { ...egresoSeleccionado.detalle_pago, interes },
        });
      }}
      fullWidth
      sx={{ ...Input, mt: 1, mb: 1 }}
    />

    
    <TextField
      label="Número de Cuotas"
      type="number"
      value={egresoSeleccionado.detalle_pago?.num_cuotas || ""}
      onChange={(e) => {
        const num = Number(e.target.value);
        if (!num || num <= 0) return;
        
  const totalConInteres = Number(
           String(egresoSeleccionado.detalle_pago.monto_total || 0).replace(/\D/g, "")
          );
           const cuotaBase = Math.floor(totalConInteres / num);
            const resto = totalConInteres - cuotaBase * num;
      
        const interes = Number(egresoSeleccionado.detalle_pago.interes) || 0;
        const dia = Number(egresoSeleccionado.detalle_pago.dia_vencimiento) || new Date().getDate();
        const mesInicial = Number(egresoSeleccionado.detalle_pago.mes_inicial ?? new Date().getMonth());
        const anioInicial = Number(egresoSeleccionado.detalle_pago.anio_inicial ?? new Date().getFullYear());

        const nuevasCuotas = Array.from({ length: num }, (_, idx) => {
            let mes = mesInicial + idx;
            let anio = anioInicial + Math.floor(mes / 12);
            mes = mes % 12;

          const fecha = new Date(anio, mes, dia);
           let montoCuota = cuotaBase;
             if (idx === num - 1) montoCuota += resto;

          return {
            numero_cuota: idx + 1,
            monto: montoCuota,
            interes,
            fecha_vencimiento: fecha.toISOString().split("T")[0],
            estado: "Pendiente",
          };
        });

        setEgresoSeleccionado({
          ...egresoSeleccionado,
          detalle_pago: { ...egresoSeleccionado.detalle_pago, num_cuotas: num, cuotas: nuevasCuotas },
        });
        setCuotas(nuevasCuotas);
      }}
      fullWidth
      sx={{ ...Input, mt: 1, mb: 2 }}
    />

  
    {cuotas.length > 0 && (
      <Box sx={{ mt: 2 }}>
        <Typography variant="subtitle2">Editar Cuotas</Typography>
        {cuotas.map((cuota, idx) => (
          <Box
            key={idx}
            sx={{ display: "grid", gridTemplateColumns: "1fr 1.5fr 1fr 1.5fr", gap: 1, mb: 1 }}
          >
            <TextField
              label="N° Cuota"
              value={cuota.numero_cuota}
              disabled
              fullWidth
              sx={Input}
            />
            <TextField
              label="Monto"
             
              value={formatCLP(cuota.monto)} // 🔹 FORMATEADO
              onChange={(e) => {
                const updated = [...cuotas];
                updated[idx].monto = Number(e.target.value.replace(/\D/g, "")); // guardar como número

                // Recalcular monto total sumando todas las cuotas
                const sumaTotal = updated.reduce((acc, c) => acc + Number(c.monto || 0), 0);

                setCuotas(updated);
                setEgresoSeleccionado({
                  ...egresoSeleccionado,
                  amount: sumaTotal, // nuevo monto bruto
                  detalle_pago: { ...egresoSeleccionado.detalle_pago, cuotas: updated, monto_total: sumaTotal },
                });
              }}
              fullWidth
              sx={Input}
            />
            <TextField
              label="Interés (%)"
              type="number"
              value={cuota.interes}
              onChange={(e) => {
                const updated = [...cuotas];
                updated[idx].interes = e.target.value;
                setCuotas(updated);
                setEgresoSeleccionado({
                  ...egresoSeleccionado,
                  detalle_pago: { ...egresoSeleccionado.detalle_pago, cuotas: updated },
                });
              }}
              fullWidth
              sx={Input}
            />
            <TextField
              label="Fecha Vencimiento"
              type="date"
              value={cuota.fecha_vencimiento}
              onChange={(e) => {
                const updated = [...cuotas];
                updated[idx].fecha_vencimiento = e.target.value;
                setCuotas(updated);
                setEgresoSeleccionado({
                  ...egresoSeleccionado,
                  detalle_pago: { ...egresoSeleccionado.detalle_pago, cuotas: updated },
                });
              }}
              fullWidth
              sx={Input}
              InputLabelProps={{ shrink: true }}
            />
          </Box>
        ))}
      </Box>
    )}
  </Box>
)}

                <FormControl fullWidth sx={Input}>
                  <InputLabel>Cuenta /banco</InputLabel>

                  <Select
                    label="Cuenta / banco"
                    value={egresoSeleccionado.detalle_pago?.cuenta_bancaria || ""}
  onChange={(e) =>
    setEgresoSeleccionado({
      ...egresoSeleccionado,
      detalle_pago: {
        ...egresoSeleccionado?.detalle_pago,
        cuenta_bancaria: e.target.value,
      },
    })
  }
                  >

                  
                    <MenuItem value="Banco Estado">Banco Estado</MenuItem>
                    <MenuItem value="Banco Chile">Banco Chile</MenuItem>
                    <MenuItem value="Santander">Santander</MenuItem>
                    <MenuItem value="BCI">BCI</MenuItem>
                    <MenuItem value="Banco Itaú">Banco Itaú</MenuItem>
                    <MenuItem value="Scotiabank">Scotiabank</MenuItem>
                    <MenuItem value="Banco Falabella">Banco Falabella</MenuItem>
                    <MenuItem value="Banco Security">Banco Security</MenuItem>
                    <MenuItem value="Banco Ripley">Banco Ripley</MenuItem>

                  
                    <MenuItem value="Otro banco">Otro banco</MenuItem>
                  </Select>

                 
                  {egresoSeleccionado.detalle_pago?.cuenta_bancaria === "Otro banco" && (
                    <TextField
                      label="Especifique el banco"
                      value={egresoSeleccionado.detalle_pago?.cuenta_bancaria || ""}
                      onChange={(e) =>
                        setEgresoSeleccionado({
                          ...egresoSeleccionado,
                          detalle_pago: {
                            ...egresoSeleccionado?.detalle_pago,
                            cuenta_bancaria: e.target.value,
                          },
                        })
                      }
                      fullWidth
                      sx={{ mt: 1 }}
                    />
                  )}
                </FormControl>


                <TextField
                  label="N° Documento"
                  value={egresoSeleccionado.detalle_pago?.numero_documento_pago}
                  onChange={(e) =>
                    setEgresoSeleccionado({
                      ...egresoSeleccionado,
                      detalle_pago: {
                        ...egresoSeleccionado?.detalle_pago,
                        numero_documento_pago: e.target.value,
                      },
                    })
                  }
                  fullWidth
                  sx={{ ...Input, mt: 1, mb: 2 }}
                />

                <TextField
                  label="Fecha Pago"
                  type="date"
                  value={egresoSeleccionado.detalle_pago?.fecha_pago}
                  onChange={(e) =>
                    setEgresoSeleccionado({
                      ...egresoSeleccionado,
                      detalle_pago: { ...egresoSeleccionado?.detalle_pago, fecha_pago: e.target.value },
                    })
                  }
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  sx={inputFechaGrande}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <CalendarToday />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  label="Monto Pagado"
                  type="number"
                  value={egresoSeleccionado.detalle_pago?.monto_pagado}
                  onChange={(e) =>
                    setEgresoSeleccionado({
                      ...egresoSeleccionado,
                      detalle_pago: { ...egresoSeleccionado.detalle_pago, monto_pagado: e.target.value },
                    })
                  }
                  fullWidth
                  sx={{ ...Input, mt: 1, mb: 2 }}
                />

              </Box> 

          

              <Box sx={{ borderRadius: 1, border: "1px solid #585857", p: 2 }}>
                <Typography variant="subtitle1" sx={SubTitulodos}>
                  Detalle ( opcional documento)
                </Typography>

                <Box mb={2}>
                  <Button component="label">
                    Subir Documento PDF
                    <input
                      type="file"
                      accept="application/pdf"
                      hidden
                     onChange={(e) => {
                      const file = e.target.files[0];

                      setEgresoSeleccionado(prev => ({
                        ...prev,
                        documento_adjunto: file
                      }));
                    }}
                    />
                  </Button>


                </Box>


                <Box>
                  <TextField
                    label="Observaciones"
                    value={egresoSeleccionado.observaciones}
                    onChange={(e) => setEgresoSeleccionado({ ...egresoSeleccionado, observaciones: e.target.value })}
                    fullWidth
                    multiline
                    minRows={3}
                    sx={InputDescripcion}
                  />

                </Box>
              </Box>



            </Box>
          )}

        </DialogContent>

        <DialogActions>
          <Button sx={buttonCancelar} onClick={handleCloseEdit}>Cancelar</Button>
          <Button sx={buttonGuardar} onClick={handleEditarIngreso}>Guardar</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openDetalle} onClose={() => setOpenDetalle(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={Titulo}>Detalle del Egreso</DialogTitle>
        <DialogContent dividers>
          {egresoSeleccionado && (

            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ border: '1px solid #a4a4a4ff', borderRadius: 1, p: 1, mb: 2 }}>
                <Grid container spacing={3}>
                  <Grid size={{ xs: 12, sm: 6 }} >
                    <Box>
                      <Typography variant="subtitle1" sx={SubTitulodos}>Fecha Registro: </Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.date}</Typography>
                    </Box>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }} >
                    <Typography variant="subtitle1" sx={SubTitulodos}>Sucursal: </Typography>
                    <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.branch?.name}</Typography>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }} >
                    <Typography variant="subtitle1" sx={SubTitulodos}>Categoria Egreso: </Typography>
                    <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.expense_category?.name}</Typography>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }} >
                    <Typography variant="subtitle1" sx={SubTitulodos}>Estado: </Typography>
                    <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.estado}</Typography>
                  </Grid>
                  <Grid size={12} >
                    <Typography variant="subtitle1" sx={SubTitulodos}>Descripción: </Typography>
                    <Typography variant="body1" sx={{ ...SubTitulodos, fontWeight: 400 }}> {egresoSeleccionado.description}</Typography></Grid>
                </Grid>
              </Box>
              <Box sx={{ border: '1px solid #a4a4a4ff', borderRadius: 1, p: 1, mb: 2 }}>
                <Typography variant="subtitle1" sx={SubTitulodos}> Información del Documento Tributario </Typography>
                <hr />
                <Box mt={1}>
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} >

                      <Typography variant="subtitle1" sx={SubTitulodos}>Campo </Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.campo}</Typography>

                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} >

                      <Typography variant="subtitle1" sx={SubTitulodos}>Origen del documento</Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.origen_documento}</Typography>

                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} >

                      <Typography variant="subtitle1" sx={SubTitulodos}>Tipo documento</Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.tipo_documento}</Typography>

                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} >

                      <Typography variant="subtitle1" sx={SubTitulodos}>Folio</Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.folio}</Typography>

                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} >

                      <Typography variant="subtitle1" sx={SubTitulodos}>Fecha emisión</Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.fecha_emision}</Typography>

                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} >

                      <Typography variant="subtitle1" sx={SubTitulodos}>Proveedor</Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.proveedor?.razon_social}</Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} > {egresoSeleccionado.proveedor?.rut_proveedor}</Typography>

                    </Grid>
                  </Grid>

                </Box>
              </Box>
              
              <Box sx={{ border: '1px solid #a4a4a4ff', borderRadius: 1, p: 1, mb: 2 }}>
                <Typography variant="subtitle1" sx={SubTitulodos}> Información del Monto </Typography>
                <hr />
                <Box mt={1}>
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} >
                      <Typography variant="subtitle1" sx={SubTitulodos}>Monto Bruto</Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} >  {formatCLP(egresoSeleccionado.amount)}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} >
                      <Typography variant="subtitle1" sx={SubTitulodos}>Iva</Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} >  {formatCLP(calcularIvaMonto(
                        Number(egresoSeleccionado.amount),
                        Number(egresoSeleccionado.iva) || "0"
                      ))}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} >
                      <Typography variant="subtitle1" sx={SubTitulodos}>Monto Neto</Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} >  {formatCLP(egresoSeleccionado.monto_neto)}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} >
                      <Typography variant="subtitle1" sx={SubTitulodos}>Monto Exento</Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} >  {formatCLP(egresoSeleccionado.monto_exento || "0")}</Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
              {egresoSeleccionado?.distributions?.length > 0 && (
              <Box sx={{ border: '1px solid #a4a4a4ff', borderRadius: 1, p: 2, mb: 2 }}>
  <Typography variant="subtitle1" sx={SubTitulodos}>
    Información del Monto por sucursal
  </Typography>

  <hr />

  <Box mt={2}>

    
    <Grid container spacing={1} sx={{ fontWeight: 600, mb: 1 }}>
      <Grid size={3}>
        <Typography sx={SubTitulodos}>Sucursal</Typography>
      </Grid>
      <Grid size={3}>
        <Typography sx={SubTitulodos}>Item</Typography>
      </Grid>
      <Grid size={2}>
        <Typography sx={SubTitulodos}>Cantidad</Typography>
      </Grid>
      <Grid size={2}>
        <Typography sx={SubTitulodos}>Unidad</Typography>
      </Grid>
      <Grid size={2}>
        <Typography sx={SubTitulodos}>Monto</Typography>
      </Grid>
    </Grid>

   
    {egresoSeleccionado?.distributions?.map((dist) => (
      <Grid
        container
        spacing={1}
        key={dist.id}
        sx={{
          borderBottom: '1px solid #eee',
          py: 1,
          alignItems: 'center'
        }}
      >
        <Grid size={3}>
          <Typography sx={{ ...SubTitulodos, fontWeight: 400 }}>
            {dist.branch?.name}
          </Typography>
        </Grid>

        <Grid size={3}>
          <Typography sx={{ ...SubTitulodos, fontWeight: 400 }}>
            {dist.item}
          </Typography>
        </Grid>

        <Grid size={2}>
          <Typography sx={{ ...SubTitulodos, fontWeight: 400 }}>
            {dist.quantity}
          </Typography>
        </Grid>

        <Grid size={2}>
          <Typography sx={{ ...SubTitulodos, fontWeight: 400 }}>
            {dist.unit}
          </Typography>
        </Grid>

        <Grid size={2}>
          <Typography sx={{ ...SubTitulodos, fontWeight: 400 }}>
            {formatCLP(dist.amount)}
          </Typography>
        </Grid>
      </Grid>
    ))}

  </Box>
</Box>
              )}

              {detallePago && (
  <Box sx={{ border: '1px solid #a4a4a4ff', borderRadius: 1, p: 1, mb: 2 }}>
    
    <Typography variant="subtitle1" sx={SubTitulodos}>
      Detalle del Pago
    </Typography>

    <hr />

    <Box mt={1}>
      <Grid container spacing={2}>

        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Typography sx={SubTitulodos}>Fecha de Pago</Typography>
          <Typography sx={{ ...SubTitulodos, fontWeight: 400 }}>
            {detallePago.fecha_pago || "-"}
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Typography sx={SubTitulodos}>Medio de Pago</Typography>
          <Typography sx={{ ...SubTitulodos, fontWeight: 400 }}>
            {detallePago.medio_pago || "-"}
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Typography sx={SubTitulodos}>Cuenta Bancaria</Typography>
          <Typography sx={{ ...SubTitulodos, fontWeight: 400 }}>
            {detallePago.cuenta_bancaria || "-"}
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Typography sx={SubTitulodos}>N° Documento</Typography>
          <Typography sx={{ ...SubTitulodos, fontWeight: 400 }}>
            {detallePago.numero_documento_pago || "-"}
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Typography sx={SubTitulodos}>Monto Pagado</Typography>
          <Typography sx={{ ...SubTitulodos, fontWeight: 400 }}>
            {formatCLP(detallePago.monto_pagado || 0)}
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Typography sx={SubTitulodos}>Saldo pendiente</Typography>
          <Typography
            sx={{
              ...SubTitulodos,
              fontWeight: 600,
              color: saldoPendiente > 0 ? "error.main" : "success.main",
            }}
          >
            {formatCLP(saldoPendiente || 0)}
          </Typography>
        </Grid>

      </Grid>
    </Box>
  </Box>
)}

{cuotas.length > 0 && (
  <Grid size={12}>
    <Box sx={{ borderRadius: 1, p: 2, mb: 2 }}>

      <Typography variant="subtitle1" sx={SubTitulodos}>
        Información de las cuotas
      </Typography>

      <hr />

      <Box mt={2}>

        <Grid container spacing={1} sx={{ fontWeight: 600, mb: 1 }}>
          <Grid size={3}><Typography sx={SubTitulodos}>Cuota</Typography></Grid>
          <Grid size={3}><Typography sx={SubTitulodos}>Monto</Typography></Grid>
          <Grid size={3}><Typography sx={SubTitulodos}>Interés</Typography></Grid>
          <Grid size={3}><Typography sx={SubTitulodos}>Vencimiento</Typography></Grid>
        </Grid>

        {cuota.map((dist, idx) => (
          <Grid
            container
            spacing={1}
            key={dist.id || idx}
            sx={{ borderBottom: '1px solid #eee', py: 1 }}
          >
            <Grid size={3}>
              <Typography sx={{ ...SubTitulodos, fontWeight: 400 }}>
                {dist.numero_cuota}
              </Typography>
            </Grid>

            <Grid size={3}>
              <Typography sx={{ ...SubTitulodos, fontWeight: 400 }}>
                {formatCLP(dist.monto || 0)}
              </Typography>
            </Grid>

            <Grid size={3}>
              <Typography sx={{ ...SubTitulodos, fontWeight: 400 }}>
                {dist.interes || 0}
              </Typography>
            </Grid>

            <Grid size={3}>
              <Typography sx={{ ...SubTitulodos, fontWeight: 400 }}>
                {dist.fecha_vencimiento || "-"}
              </Typography>
            </Grid>
          </Grid>
        ))}

      </Box>
    </Box>
  </Grid>
)}
              <Box sx={{ border: '1px solid #a4a4a4ff', borderRadius: 1, p: 1, mb: 2 }}>
                <Typography variant="subtitle1" sx={SubTitulodos}> Impuestos y Retenciones </Typography>
                <hr />
                <Box mt={1}>
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }} >
                      <Typography variant="subtitle1" sx={SubTitulodos}>Tipo de Retención </Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} >  {egresoSeleccionado.tipo_retencion}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }} >
                      <Typography variant="subtitle1" sx={SubTitulodos}>Monto retenido</Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} >  {egresoSeleccionado.monto_retenido}</Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Box>

              <Box sx={{ border: '1px solid #a4a4a4ff', borderRadius: 1, p: 1, mb: 2 }}>
                <Typography variant="subtitle1" sx={SubTitulodos}> Evidencias y Documentos Adjuntos
                </Typography>
                <hr />
                <Box mt={1}>
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }} >
                      <Typography variant="subtitle1" sx={SubTitulodos}>Observaciones: </Typography>
                      <Typography variant="subtitle1" sx={{ ...SubTitulodos, fontWeight: 400 }} >  {egresoSeleccionado.observaciones}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }} >
                      <Typography variant="subtitle1" sx={SubTitulodos}>Documento Adjunto</Typography>
                      
                      <Button sx={buttonGuardar} disabled={!pdfUrl}   onClick={() => descargarPdfEgreso(egresoSeleccionado.id)}>
                        {pdfUrl ? (
                          <a
                            style={{ textDecoration: "none", color: "inherit" }}
                          >
                            Ver PDF
                          </a>
                        ) : (
                          "Sin PDF"
                        )}
                      </Button>

                    </Grid>
                  </Grid>
                </Box>
              </Box>




              <Typography variant="subtitle1" sx={SubTitulodos}>Egreso creado por el administrador {egresoSeleccionado.user?.name}</Typography>


            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDetalle(false)} sx={buttonCancelar}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog> 

    </>
  );
};
